import React, { Component } from "react";
import * as aor from "react-admin";
import CardActions from "@material-ui/core/CardActions";
import DeleteButton from "../../components/DeleteButton";
import EnableButton from "../../components/EnableButton";
import EmailButton from "../../components/EmailButton";
import NotificationButton from "../../components/NotificationButton";
import ProgressBar from "../../components/ProgressBar";
import PasswordField from "../../components/PasswordField";
import StatusChip from "../../components/StatusChip";
import { InstallationEventStatus } from "../../common/statuses";
import TranslatedText from "../../components/TranslatedText";
import { POLICY_INSTALLATIONS } from "../../common/rolesManagement";
import RedoProvisioningButton from "./RedoProvisioningButton";
import { withStyles } from "@material-ui/core";
import { getPolicies } from "../../common/authClient";
import { Field } from "redux-form";
import CompanyTransfer from "../../components/CompanyTransfer";
import CustomerTransfer from "../../components/CustomerTransfer";
import AccessUrlTransfer from "../../components/AccessUrlTransfer";
import AdvancedDialogButton from "../../components/AdvancedDialogButton";
import DetailsDialogButton from "../../components/DetailsDialogButton";
import ExtraVarsFields from "../../components/ExtraVarsFields";
import CustomForm from "../../components/CustomForm";
import LocalOffer from "@material-ui/icons/LocalOffer";
import restClient from "../../common/restClient";
import Tooltip from "@material-ui/core/Tooltip";
import Snackbar from "@material-ui/core/Snackbar";
import it from "../../messages/it";
import { OperationType } from "../../common/operationTypes";

const LIST_REFRESH_INTERVAL = 45000; // 1000 ms = 1 second

class MyDetail extends Component {
    state = { operation: [] };

    componentDidMount() {
        if (this.props.data && this.props.data.installation_type_id) {
            const params = {
                pagination: { page: 1, perPage: 10000 },
                sort: { field: "name", order: "asc" },
                filter: {
                    installation_type_id: this.props.data.installation_type_id
                },
                filter_type: [OperationType.GetInstallationInfo]
            };
            restClient("GET_LIST", "operations", params).then(
                result => {
                    const data = result.data.map(item => {
                        return {
                            id: item.operation_type_name,
                            name: item.operation_type_description
                        };
                    });
                    this.setState({ operation: data });
                },
                error => {
                    return error;
                }
            );
        }
    }
    render() {
        return (
            this.state.operation.length > 0 && (
                <DetailsDialogButton
                    data={this.props.data}
                    basePath={this.props.basePath}
                    permissions={this.props.permissions}
                    refreshInterval={LIST_REFRESH_INTERVAL}
                />
            )
        );
    }
}

const Actions = ({ permissions, basePath, data }) => {
    return (
        <CardActions
            style={{ zIndex: 2, display: "inline-block", float: "right" }}
        >
            {" "}
            {data && (
                <MyDetail
                    data={data}
                    basePath={basePath}
                    permissions={permissions}
                    refreshInterval={LIST_REFRESH_INTERVAL}
                />
            )}
            {data &&
                permissions &&
                data.status !== InstallationEventStatus.UpdateStarted &&
                (permissions.includes(POLICY_INSTALLATIONS.LOCK) ||
                    permissions.includes(POLICY_INSTALLATIONS.FORCE_DELETE) ||
                    permissions.includes(
                        POLICY_INSTALLATIONS.FORCE_PROVISIONING_SUCCEEDED
                    ) ||
                    permissions.includes(
                        POLICY_INSTALLATIONS.FORCE_PROVISIONING_FAILED
                    )) && (
                    <AdvancedDialogButton
                        data={data}
                        basePath={basePath}
                        permissions={permissions}
                    />
                )}
            {//DeleteButton (used for disable) is visible only if installation is not disabled
            data &&
                !data.locked &&
                !data.disabled &&
                data.cancellation_available &&
                // FIXME il pulsante di cancellazione non viene mostrato se lo stato è in update (probabilmente per la voltura)
                // il controllo viene già fatto lato backend, eventualmente andrebbe genralizzato per qualsiasi operazione in corso
                data.status !== InstallationEventStatus.UpdateStarted && (
                    <DeleteButton
                        undoable={false}
                        basePath={basePath}
                        resource="installations"
                        message={"Disinstallazione avviata"}
                        record={data}
                        text={"Cancella"}
                        dialogContentTitle={"Cancella"}
                        dialogContentText={
                            "resources.installations.actions.delete_anyway"
                        }
                        booking={true}
                    />
                )}
            {data &&
                !data.locked &&
                data.disabled &&
                data.status !== InstallationEventStatus.uninstallationStarted &&
                data.status !== InstallationEventStatus.uninstallationRunning &&
                data.status !==
                    InstallationEventStatus.uninstallationSucceeded &&
                data.status !== InstallationEventStatus.UpdateStarted && (
                    <EnableButton
                        action="enable_installation"
                        resource_id={data.id}
                        current_entity="installations"
                        redirect="/installations"
                    />
                )}
            {//EmailButton is visible only when the status is "PROVISIONING_SUCCEEDED"
            data &&
                (data.status ===
                    InstallationEventStatus.provisioningSucceeded ||
                    data.status === InstallationEventStatus.UpdateSucceeded ||
                    data.status ===
                        InstallationEventStatus.confirmationEmailSent) &&
                permissions &&
                permissions.includes(POLICY_INSTALLATIONS.SEND_MAIL) && (
                    <EmailButton
                        action="provisioning_succeeded_mail"
                        resource_id={data.id}
                    />
                )}
            {//ResetNotificationButton is visible only when tsx_notification_id is not null and cancellation_user_id is null
            // Può capitare quando la disdetta è stata annullata (non è nello stato In cancellazione) ma non è stato possibile inviare l'annullamento della notifica
            permissions &&
                permissions.includes(POLICY_INSTALLATIONS.TSX_NOTIFICATION) &&
                data &&
                data.staus !== InstallationEventStatus.pendingDelete &&
                data.tsx_notification_id &&
                !data.cancellation_user_id && (
                    <NotificationButton type="reset" resource_id={data.id} />
                )}{" "}
            {//NewNotificationButton is visible only when tsx_notification_id is null and cancellation_user_id is not null
            // Può capitare quando l'installazione è in disdetta ma dal cron non si è riusciti a inviare la notifica
            permissions &&
                permissions.includes(POLICY_INSTALLATIONS.TSX_NOTIFICATION) &&
                data &&
                data.status === InstallationEventStatus.pendingDelete &&
                !data.tsx_notification_id &&
                data.cancellation_user_id && (
                    <NotificationButton type="new" resource_id={data.id} />
                )}
            {//RedoProvisioningButton is visible only for admin_console when the status is "PROVISIONING_FAILED"
            data &&
                data.status === InstallationEventStatus.provisioningFailed &&
                permissions &&
                permissions.includes(POLICY_INSTALLATIONS.RETRY) &&
                permissions.includes(POLICY_INSTALLATIONS.UPDATE) && (
                    <RedoProvisioningButton record={data} />
                )}
            {/* {permissions &&
                permissions.includes(ACTION_CRUD_INSTALLATIONS.UPDATE) && (
                    <aor.EditButton basePath={basePath} record={data} />
                )} */}
            <aor.ListButton basePath={basePath} />
        </CardActions>
    );
};

const styles = {
    table: {
        // height: 400,
        width: "100%"
        // overlflow: "overlay"
    },
    dateCellStyle: {
        whiteSpace: "nowrap"
    },
    noMaxWidth: {
        maxWidth: "none"
    },
    messageCell: {
        textOverflow: "ellipsis",
        overlflow: "hidden",
        maxWidth: "30rem"
    },
    message: {
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        width: "100%",
        overflow: "hidden"
    },
    rowCell: {}
};

function textToClipboard(text) {
    var dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
}

const MyRow = withStyles(styles)(({ ...props }) => {
    const [open, setOpen] = React.useState(false);
    var date = new Date();
    if (props && props.record) {
        date = new Date(props.record.created_at);
    }
    const dtf = new Intl.DateTimeFormat("it-IT", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: false
    });
    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setOpen(false);
    };
    return (
        <aor.DatagridRow
            {...props}
            onClick={() => {
                setOpen(true);
                textToClipboard(
                    "[" +
                        dtf.format(date) +
                        "] " +
                        it.resources.events.types[props.record.type] +
                        ": " +
                        props.record.message
                );
            }}
        >
            <StatusChip
                record={props.record}
                source="type"
                translationRoot={"resources.events.types"}
            />

            <Tooltip
                title={props.record.message}
                classes={{ tooltip: props.classes.noMaxWidth }}
                cellClassName={props.classes.messageCell}
            >
                <aor.TextField
                    record={props.record}
                    source="message"
                    sortable={false}
                    className={props.classes.message}
                ></aor.TextField>
            </Tooltip>

            <Snackbar
                open={open}
                onClose={handleClose}
                message="Messaggio evento copiato"
                autoHideDuration={1000}
            />
            <aor.DateField
                record={props.record}
                source="created_at"
                showTime={true}
                options={{ hour12: false }}
                cellClassName={props.classes.dateCellStyle}
            />
            <ProgressBar
                record={props.record}
                source="progress_status"
                sortable={false}
            />
        </aor.DatagridRow>
    );
});

const MyDatagridBody = props => {
    const { classes, ...others } = props;
    delete classes.thead;
    delete classes.tbody;
    delete classes.headerRow;
    delete classes.headerCell;
    delete classes.checkbox;
    delete classes.row;
    delete classes.clickableRow;
    delete classes.rowEven;
    delete classes.rowOdd;
    delete classes.expandHeader;
    delete classes.expandIconCell;
    delete classes.expandIcon;
    delete classes.expanded;

    return <aor.DatagridBody classes={classes} {...others} row={<MyRow />} />;
};

const MyDataGrid = withStyles(styles)(({ ...props }) => {
    // workaround for react-admin, because the total was always undefined
    props.total = props.ids ? props.ids.length : 0;
    const { classes, ...others } = props;
    return (
        <aor.Datagrid
            {...others}
            children={<MyDatagridBody />}
            body={<MyDatagridBody />}
        />
    );
});

const MyReferenceManyField = withStyles(styles)(({ classes, ...props }) => (
    <aor.Labeled
        label="resources.events.namePlural"
        {...props}
        className={classes.table}
    >
        <aor.ReferenceManyField
            label="resources.events.namePlural"
            perPage={1000}
            reference="events"
            target="installation_id"
            sort={{ field: "created_at", order: "DESC" }}
        >
            <MyDataGrid />
        </aor.ReferenceManyField>
    </aor.Labeled>
));

const MyDateField = ({ ...props }) => {
    if (props.record && props.record.disabled_at) {
        return (
            <aor.Labeled label="resources.installations.fields.disabled_at">
                <aor.DateField
                    source="disabled_at"
                    showTime={false}
                    record={props.record}
                />
            </aor.Labeled>
        );
    } else return <div />;
};

class MyTicketButton extends Component {
    state = { ticket_id: null };

    componentDidMount() {
        restClient("GET_ONE_BY_PARAMETERS", "tickets", {
            installation_id: this.props.record.id
        }).then(
            result => {
                if (result && result.data[0]) {
                    this.setState({ ticket_id: result.data[0].id });
                }
            },
            err => {
                return null;
            }
        );
    }

    render() {
        return (
            this.state.ticket_id && (
                <aor.EditButton
                    icon={<LocalOffer />}
                    label={
                        <TranslatedText
                            resource_name={`resources.installations.actions.ticket`}
                        />
                    }
                    basePath="/tickets"
                    record={{ id: this.state.ticket_id }}
                />
            )
        );
    }
}

export default ({ permissions, ...props }) => (
    <aor.Show
        {...props}
        actions={<Actions permissions={getPolicies()} />}
        title={"resources.installations.nameSingular"}
    >
        <CustomForm>
            <MyDateField />
            <aor.TextField source="id" label="Id" />
            <Field
                {...props}
                name="transfer"
                component={CustomerTransfer}
                permissions={getPolicies()}
                isAdminRole={
                    permissions &&
                    permissions.includes(POLICY_INSTALLATIONS.READ_PWD_ADMIN)
                }
            />
            {getPolicies() &&
                getPolicies().includes(POLICY_INSTALLATIONS.SHOW_COMPANY) && (
                    <Field
                        {...props}
                        name="ctransfer"
                        component={CompanyTransfer}
                        permissions={getPolicies()}
                        isAdminRole={
                            permissions &&
                            permissions.includes(
                                POLICY_INSTALLATIONS.READ_PWD_ADMIN
                            )
                        }
                    />
                )}
            <aor.TextField
                source="installation_type_label"
                label="resources.installations.fields.installation_type_id"
            />
            <Field
                {...props}
                name="url_transfer"
                component={AccessUrlTransfer}
                permissions={getPolicies()}
                isAdminRole={
                    permissions &&
                    permissions.includes(POLICY_INSTALLATIONS.READ_PWD_ADMIN)
                }
            />
            {//admin_password is visible only if role is ROLE_ADMIN_CONSOLE"
            permissions &&
                permissions.includes(POLICY_INSTALLATIONS.READ_PWD_ADMIN) && (
                    <PasswordField
                        source="admin_password"
                        label="resources.installations.fields.admin_password"
                        {...props}
                    />
                )}
            <PasswordField
                source="admin_l2_password"
                label="resources.installations.fields.admin_l2_password"
                {...props}
            />
            <ExtraVarsFields />
            {/* <aor.TextField source="company_id" /> */}
            <MyTicketButton />
            <MyReferenceManyField />
        </CustomForm>
    </aor.Show>
);



// WEBPACK FOOTER //
// ./src/resources/Installations/Show.js